import ApiService from '@/services/api';
import { EntityBuilder } from '@decahedron/entity';
import Picture from '@/entities/Picture';

let instance: PictureService = null;

export default class PictureService {
    apiService: ApiService = null;

    constructor() {
        if (!instance) {
            this.apiService = new ApiService();
            instance = this;
        }

        return instance;
    }

    upload(picture: File, type: string) {
        const data = new FormData();
        data.append('picture', picture);
        data.append('type', type);
        return this.apiService.post('pictures', data)
            .then((response) => EntityBuilder.buildOne(Picture, response.data));
    }

    uploadData(data: string, fielname: string, type: string) {
        return this.urltoFile(data, fielname)
            .then((picture) => this.upload(picture, type));
    }

    protected dataURLtoFile(dataurl: string, filename: string) {
        const arr = dataurl.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);

        while (n) {
            u8arr[n] = bstr.charCodeAt(n);
            n -= 1;
        }

        return new File([u8arr], filename, { type: mime });
    }

    protected urltoFile(url: string, filename: string, mimeType: string = null) {
        const mime = mimeType || url.split(',')[0].match(/:(.*?);/)[1];

        return fetch(url)
            .then((res) => res.arrayBuffer())
            .then((buf) => new File([buf], filename, { type: mime }));
    }
}
